import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { getFilePathForView, getPreviewUrl } from '../../library/constants';

export const PDFViewer = ({ path, type, project_id, item_id }) => {
    if (type == "pdf") {
        return <object
            type="application/pdf"
            data={getFilePathForView(path, project_id, item_id)} width="100%"
            height="500px">
            <p>Unable to load file.Click on the link below to view the file</p>
            <Button href={getFilePathForView(path, project_id, item_id)}>View File</Button>
        </object>
    }
    else if (type == "svg") {
        return (
            <img src={getPreviewUrl(path, project_id, item_id)} alt="preview" width="100%"
                height="auto" style={{ maxHeight: '400px' }} />
        )
    }
    else {
        return (
            <object
                data={getFilePathForView(path, project_id, item_id)}
                width="100%"
                height="auto" style={{ maxHeight: '400px' }} >
                <p>Unable to load file.Click on the link below to view the file</p>
                <Button href={getFilePathForView(path, project_id, item_id)}>View File</Button>
            </object>

        );
    }

}

PDFViewer.propTypes = {
    path: PropTypes.string,
    type: PropTypes.string,
    project_id: PropTypes.number,
    item_id: PropTypes.number,

}

